import Vue from 'vue'
import Router from 'vue-router'
import Poems from './views/Poems.vue'
import About from './views/About.vue'

import Poseidon from './markdown/poems/Poseidon.md'
import RainGirl from './markdown/poems/RainGirl.md'
import NatureShrugs from './markdown/poems/NatureShrugs.md'
import Cogitations from './markdown/poems/Cogitations.md'
import Library from './markdown/poems/Library.md'
import Odin from './markdown/poems/Odin.md'

var poemSections = [
  {
    "name": "Nature",
    "poems": [
      {
        "name":"Poseidon",
        "class":"ocean",
        "markDown":Poseidon
      },
      {
        "name":"The Rain Girl",
        "class":"rain",
        "markDown":RainGirl
      },
      {
        "name":"Nature Shrugs",
        "class":"natureShrugs",
        "markDown":NatureShrugs
      }
    ]
  },
  {
    "name": "Surreal",
    "poems": [
      {
        "name":"Cogitations",
        "class":"cogitations",
        "markDown":Cogitations
      },
      {
        "name":"Library",
        "class":"library",
        "markDown":Library
      },
      {
        "name":"The One-eyed Mad God",
        "class":"raven",
        "markDown":Odin
      }
    ]
  },
];

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'nature',
      component: Poems,
      props: poemSections[0]
    },
    {
      path: '/surreal',
      name: 'surreal',
      component: Poems,
      props: poemSections[1]
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})